import { browserLogger } from '@newfront-insurance/dd-rum';

export interface MSGraphManager {
  // Settings
  isEnabled(): boolean;
  enable(): void;
  disable(): void;

  // Feature flag integration
  setFeatureFlagEnabled(enabled: boolean): void;
}

class MSGraphManagerImpl implements MSGraphManager {
  private featureFlagEnabled: boolean = true;

  private enabled: boolean = false;

  /**
   * Check if Outlook Connect is enabled by feature flag and user preference
   */
  isEnabled(): boolean {
    if (!this.featureFlagEnabled) {
      return false;
    }

    return this.enabled;
  }

  /**
   * Enable Outlook Connect (in-memory only — persistence is handled by the server)
   */
  enable(): void {
    this.enabled = true;
    browserLogger.debug('[MS Graph Manager] Outlook Connect enabled');
  }

  /**
   * Disable Outlook Connect (in-memory only — persistence is handled by the server)
   */
  disable(): void {
    this.enabled = false;
    browserLogger.debug('[MS Graph Manager] Outlook Connect disabled');
  }

  /**
   * Set whether the nova-tools-graph-api feature flag is enabled
   */
  setFeatureFlagEnabled(enabled: boolean): void {
    this.featureFlagEnabled = enabled;
    browserLogger.debug('[MS Graph Manager] Feature flag updated', { enabled });
  }
}

// Singleton instance
export const msGraphManager = new MSGraphManagerImpl();
